import { render, staticRenderFns } from "./GuestList.vue?vue&type=template&id=2f224ac1&"
import script from "./GuestList.vue?vue&type=script&lang=js&"
export * from "./GuestList.vue?vue&type=script&lang=js&"
import style0 from "./GuestList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports